<app-contact-links></app-contact-links>

<app-lang-switch [theme]="'light'"></app-lang-switch>